import { render, staticRenderFns } from "./LexusPostShow.vue?vue&type=template&id=a5e2c442&"
import script from "./LexusPostShow.vue?vue&type=script&lang=js&"
export * from "./LexusPostShow.vue?vue&type=script&lang=js&"
import style0 from "./LexusPostShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports